import { Media } from 'enums';
import styled, { css } from 'styled-components';

export const ModalStyle = css`
  flex-direction: column;
  text-align: center;
  gap: 24px;
  line-height: 25px;

  @media ${Media.notebook} {
    gap: 32px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${Media.notebook} {
    gap: 16px;
  }
`;

export const ButtonWrapper = styled.div<{ areButtonsHorizontal?: boolean }>`
  display: flex;
  flex-direction: ${({ areButtonsHorizontal }) =>
    areButtonsHorizontal ? 'row-reverse' : 'column'};

  gap: 16px;
  @media ${Media.notebook} {
    gap: 24px;
  }

  > button {
    ${({ areButtonsHorizontal }) => areButtonsHorizontal && { flexShrink: 1 }}

    gap: 10px;
    @media ${Media.notebook} {
      gap: 16px;
    }
  }
`;
